module.exports = __webpack_public_path__ + "static/img/10.b8ae4fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/10.png
// module id = Z6uo
// module chunks = 0